export default __webpack_public_path__ + "static/media/slideshow_step4_en.774d38ed.png";